module.exports = __webpack_public_path__ + "img/ssyx_22.2123fbb2.jpg";